var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('div',{staticClass:"d-flex"},[_c('SingleBlock',{attrs:{"color":_vm.color,"target":_vm.target,"progress":_vm.progress}})],1):_c('MoonSpinner',{attrs:{"color":"#F9F9F9","loading":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }